import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import axios from 'axios';
import { axiosPrivate } from '../../Helpers/axios';

function* getActiveAgentResponse({ payload: { offset, limit } }) {
  try {
    // const response = yield call(
    //   axios.get,
    //   `https://s3dhj1lb-7070.inc1.devtunnels.ms/cou-dashboard/agents/list?page=${offset ? offset : 1}&limit=${limit ? limit : 10}`
    // );
     const response = yield call(
            axiosPrivate.get,
            `/api/cou-dashboard/agents/list?page=${offset ? offset : 1}&limit=${limit ? limit : 100}`
          );
    yield put(actions.getActiveAgentSuccess(response?.data, response?.data?.total));
  } catch (error) {
    yield put(actions.getActiveAgentFailed(error.response?.data?.message ? error.response.data.message : error));
  }
}

function* getAgentTransactionsResponse({ payload: { offset, limit,fromDate,toDate } }) {
  try {
    // const response = yield call(
    //   axios.get,
    //   `https://s3dhj1lb-7070.inc1.devtunnels.ms/cou-dashboard/agents/transaction?page=${offset ? offset : 1}&limit=${limit ? limit : 10}${fromDate?`&fromDate=${fromDate}`:""}${toDate?`&toDate=${toDate}`:""}`
    // );
     const response = yield call(
            axiosPrivate.get,
            `/api/cou-dashboard/agents/transaction?page=${offset ? offset : 1}&limit=${limit ? limit : 100}${fromDate?`&fromDate=${fromDate}`:""}${toDate?`&toDate=${toDate}`:""}`
          );
    // Fix: Use correct nesting for data and total
    yield put(actions.getAgentTransactionsSuccess(response?.data, response?.data?.total));
  } catch (error) {
    yield put(actions.getAgentTransactionsFailed(error.response?.data?.message ? error.response.data.message : error));
  }
}
function* getAgentTransactionsDetailsResponse({ payload }) {
  try {
    // const response = yield call(
    //   axios.get,
    //   `https://s3dhj1lb-7070.inc1.devtunnels.ms/cou-dashboard/agents/transaction-details/${agentId}`
    // );
    // //console.log("Response from getAgentTransactionsDetailsResponse:", response);
    const { agentId, fromDate, toDate } = payload;
    //console.log( 'DATA => ', agentId, fromDate, toDate)
     const response = yield call(
            axiosPrivate.get,
            `/api/cou-dashboard/agents/transaction-details/${agentId}?fromDate=${fromDate ? fromDate : ''}&toDate=${toDate ? toDate : ''}`
          );
    // Fix: Use correct nesting for data and total
    const filteredData = response?.data?.filter(item => item.totalTransactionCount !== 0);
    yield put(actions.getAgentTransactionsDetailsSuccess(filteredData));
  } catch (error) {
    yield put(actions.getAgentTransactionsDetailsFailed(error.response?.data?.message ? error.response.data.message : error));
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.GET_ACTIVE_AGENT, getActiveAgentResponse)]);
  yield all([takeEvery(actions.GET_AGENT_TRANSACTIONS, getAgentTransactionsResponse)]);
  yield all([takeEvery(actions.GET_AGENT_TRANSACTIONS_DETAILS, getAgentTransactionsDetailsResponse)]);
}


